<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
/**
 * The Base Layout
 * --------------------------------
 * Used in ALL layouts. Wraps all normal pages
 * - adds basics like error toasts, confirm dialogs, loading overlays etc
 * - adds SEO head
 */

const { bodyClasses = '' } = defineProps<{
    bodyClasses?: string;
}>();

const route = useRoute();
const { t } = useNuxtApp().$i18n;
const head = useLocaleHead({ seo: true });
const title = computed(() => route.meta.title ? `${t(route.meta.title as string)} - Top of Travel | jungfrau.ch` : 'Top of Travel | jungfrau.ch');
const isSubFlow = inject('isSubFlow', false);

useHead({
    bodyAttrs: {
        tagDuplicateStrategy: 'replace',
        class: [
            'bg-background-1',
            'typo-copy',
            'text-brand-b',
        ]
            .concat(bodyClasses)
            .join(' '),
    },
});
</script>

<template>
    <div>
        <Html :lang="head.htmlAttrs?.lang">
            <Head>
                <Title>{{ title }}</Title>
            </Head>
            <Body>
                <div
                    class="
                    grid
                    min-h-dvh
                    grid-rows-[min-content_auto]
                "
                >
                    <div class="sticky top-0 z-31 print:hidden" :class="isSubFlow ? 'bg-background-2' : ''">
                        <TheToasts />
                    </div>

                    <div>
                        <slot />
                    </div>
                </div>
                <TheLoadingOverlay />
                <TheConfirmDialog />
                <ClientOnly>
                    <TheDevHelper v-if="useRuntimeConfig().public.enableDevHelpers" />
                    <VueQueryDevtools
                        position="right"
                        button-position="bottom-left"
                        class="print:hidden"
                    />
                </ClientOnly>
            </Body>
        </Html>
    </div>
</template>
